// Angular does not support ng-change on input[type=file] elements:
// https://github.com/angular/angular.js/issues/1375
// http://stackoverflow.com/questions/17922557

module.exports = function() {

  return {
    restrict: 'A',
    require: 'ngModel',

    link: function(scope, element, attrs, ngModel) {

      var onChange = function(event) {
        var files = event.target.files || [];
        var value = attrs.multiple ? files : files[0];

        scope.$apply(function() {
          ngModel.$setViewValue(value);
          ngModel.$render();
        });
      };

      element.on('change', onChange);
    }
  };

};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/directives/fileOnChange.js
 ** module id = 141
 ** module chunks = 1
 **/